import styled, { keyframes } from "styled-components";

const blink = keyframes`
    0% { opacity: 0.2; }
    20% { opacity: 1; }
    100% { opacity: 0.2; }
`;

export const ChatContainer = styled.div`
    position: fixed;
    bottom: 160px;
    right: 15px;
    width: 350px;
    max-height: 500px;
    height: 50vh;
    background-color: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: 0.5s ease;
    transform-origin: bottom right;
    z-index: ${({ $isOpen }) => ($isOpen ? '1000' : "-1")};
    opacity: ${({ $isOpen }) => ($isOpen ? '1' : "0")};
    transform: ${({ $isOpen }) => ($isOpen ? 'scale(1)' : "scale(0)")};

    @media (min-width: 720px) {
        bottom: 90px;
        right: 20px;
    }
    @media (min-width: 1281px) {
        bottom: 90px;
        right: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        bottom: 190px;
        right: 20px;
    }
`;

export const ChatHeader = styled.div`
    background-color: #006560;
    color: white;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
    }

    button {
        background: none;
        border: none;
        color: white;
        font-size: 18px;
        cursor: pointer;
    }
`;

export const ChatMessages = styled.div`
    flex: 1;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;

    .user-bubble {
        align-self: flex-end;
        background-color: #006560;
        color: #fff;
        padding: 8px 12px;
        border-radius: 12px;
        max-width: 80%;
        word-break: break-word;
    }

    .iris-bubble {
        align-self: flex-start;
        background-color: #f1f1f1;
        color: #000;
        padding: 8px 12px;
        border-radius: 12px;
        max-width: 80%;
        word-break: break-word;

        p, ul, ol { margin: 0 0 8px; }
        p:last-child { margin-bottom: 0; }
        ul, ol { padding-left: 20px; }

        table {
            display: block;
            overflow-x: auto;
            border-collapse: collapse;
            margin: 8px 0;
            font-size: 13px;
        }

        th, td {
            border: 1px solid #cfe0df;
            padding: 6px 8px;
            text-align: left;
            word-break: normal;
        }

        th {
            background-color: #006560;
            color: #fff;
            font-weight: 600;
        }

        td { background-color: #fff; }
        tr:nth-child(even) td { background-color: #eef5f5; }

        a { color: #006560; font-weight: 600; }

        h1, h2, h3, h4, h5, h6 { font-size: 1em; margin: 0 0 8px; }
    }
`;

export const MessageBubble = styled.div`
    align-self: ${({ $sender }) => ($sender === "user" ? "flex-end" : "flex-start")};
    background-color: ${({ $sender }) => ($sender === "user" ? "#006560" : "#f1f1f1")};
    color: ${({ $sender }) => ($sender === "user" ? "#fff" : "#000")};
    padding: 8px 12px;
    border-radius: 12px;
    max-width: 80%;
    word-break: break-word;
`;

export const ChatInput = styled.div`
    display: flex;
    padding: 8px;
    border-top: 1px solid #eee;
    background-color: #fafafa;

    input {
        flex: 1;
        border: none;
        padding: 8px;
        border-radius: 8px;
        outline: none;
        font-size: 14px;
    }

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ $loading }) => ($loading ? "#ccc" : "#006560")};
        color: ${({ $loading }) => ($loading ? "#666" : "white")};
        color: white;
        border: none;
        width: 40px;
        height: 40px;
        margin-left: 6px;
        border-radius: 8px;
        cursor: pointer;
        font-size: 16px;
    }
`;

export const IrisButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 95px;
    right: 25px;
    width: 60px;
    height: 60px;
    background-color: #006560;
    border: none;
    border-radius: 50%;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    outline: none;
    cursor: pointer;
    font-size: 24px;
    color: white;
    z-index: 1001;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.05);
    }


    @media (min-width: 720px) {
        bottom: 20px;
        right: 20px;
    }
    @media (min-width: 1281px) {
        bottom: 20px;
        right: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        bottom: 120px;
        right: 30px;
    }
`;


export const LoadingDots = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 20px;

    span {
        width: 6px;
        height: 6px;
        margin: 0 2px;
        background-color: ${({ color }) => color || "#006560"};
        border-radius: 50%;
        animation: ${blink} 1.4s infinite both;

        &:nth-child(1) {
        animation-delay: 0s;
        }
        &:nth-child(2) {
        animation-delay: 0.2s;
        }
        &:nth-child(3) {
        animation-delay: 0.4s;
        }
    }
`;